import { render, staticRenderFns } from "./BtnAffiliateShare.vue?vue&type=template&id=9af278e6&scoped=true"
import script from "./BtnAffiliateShare.vue?vue&type=script&lang=js"
export * from "./BtnAffiliateShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af278e6",
  null
  
)

export default component.exports